import { classes, stylesheet } from 'typestyle'

/* Common ======================================================================================= */
import useValue from '../../../hooks/use-value'

/* Components =================================================================================== */
import { Box } from '../../../components/box/box.component'
import { Button } from '../../../components/button'
import { Heading } from '../../../components/text/heading.component'
import { Line } from '../../../components/line'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text/text.component'

/* Styles ======================================================================================= */
import { p12 } from '../../../styles/styleset/padding/p12'
import { ml4 } from '../../../styles/styleset/margin/ml4'
import { mt8 } from '../../../styles/styleset/margin/mt8'
import { mt4 } from '../../../styles/styleset/margin/mt4'
import { Switch } from '../../../modules/components/switch'
import { pr20 } from '../../../styles/styleset/padding/pr20'
import { Form } from '../../../components/form'

Modal.add('GPTEdit', (props: any) => {
  const [value, $value] = useValue(props.value || '')
  const { values, labels } = props
  const [exclude, $exclude ] = useValue({})

  const onClose = () => Modal.pop()
  const onSubmit = () => {
    if (value) {
      const refDate = new Date()

      refDate.setHours(value.split(':')[0])
      refDate.setMinutes(value.split(':')[1])

      props.onSubmit(refDate.toISOString())
    }
    Modal.pop()
  }

  const result = Object.keys(values).filter(key => values[key] && labels[key])

  return (
    <Box
      className={classes(STYLES.parent)}
      minWidth={320}
      rounded
      fullWidth
      fullHeight
      alignCenter
      row
    >
      <Form onSubmit={() => {
        // console.log(exclude, values)
      }}>
        <Box className={classes(p12)} baseline="none" fullWidth row>
          <Text baseline="surface" lighter size="sm">
            AI Assistant Result
          </Text>
          {result.length > 0 ? (
            <Heading size="xs">Here is what we picked up</Heading>
          ) : (
            <Heading size="xs">Sorry we couldn't pick up anything. Please try again!</Heading>
          )}
        </Box>
        <Line />
        {result.length > 0 && (
          <>
            <Box className={p12} baseline="none" maxHeight={400} style={{ overflow: 'auto' }}>
              {result.map((key, i) => {
                return (
                  values[key] &&
                  labels[key] && (
                    <Box key={key} className={classes(i !== 0 && mt8, p12)} baseline='background' rounded flex spaceBetween alignCenterY>
                      <Box baseline='none' row className={pr20}
                        style={{
                          opacity: exclude[key] ? 0.6 : 1,
                          transition: 'all .2s ease'
                        }}
                      >
                        <Text size="xs" baseline="surface" lighter>
                          {labels[key]}
                        </Text>
                        <Text size="sm" baseline="surface" className={mt4}>
                          {values[key]}
                        </Text>
                      </Box>
                      <span
                        onClick={() => {
                          $exclude.set(prev => {
                            const newPrev = {...prev}
                            newPrev[key] = !newPrev[key]
                            return newPrev
                          })
                        }}
                      >
                        <Switch value={!exclude[key]} />
                      </span>
                    </Box>
                  )
                )
              })}
            </Box>
            <Line />
          </>
        )}
        <Box className={p12} alignRight baseline="none">
          <Button square label="Cancel" size="sm" onClick={onClose} />
          {result.length === 0 ? (
            <Button
              disabled={!$value}
              square
              label="Confirm"
              className={ml4}
              baseline="primary"
              size="sm"
              onClick={Modal.pop}
            />
          ) : (
            <Button
              disabled={!$value}
              square
              label="Save"
              className={ml4}
              baseline="primary"
              size="sm"
              type='submit'
            />
          )}
        </Box>
      </Form>
    </Box>
  )
})

const STYLES = stylesheet({
  parent: {
    backgroundColor: 'none',
  },
  container: {
    backgroundColor: 'none',
    borderRadius: '8px 8px 0 0',
  },
})
